import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// 301-style client redirect from old domain to canonical meldcodezoeker.nl.
// (Lovable hosting handles the actual 301 once DNS is removed; this is a safety net.)
if (typeof window !== "undefined") {
  const host = window.location.hostname;
  const legacy = ["isde-meldcode-zoeker.nl", "www.isde-meldcode-zoeker.nl", "isde-meldcode-finder.lovable.app"];
  if (legacy.includes(host)) {
    window.location.replace(`https://meldcodezoeker.nl${window.location.pathname}${window.location.search}${window.location.hash}`);
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
